import { axiosInstance } from "./axiosInstance";

export const getChat = async (data: any) => {
    return await axiosInstance.post(`/api/feature/chatbot`, data);
}